import React from "react";
import { Modal } from "antd";
import DoctorInfoView from "./DoctorInfoView";

import {
  strings,
  showSuccessNotification,
  bytesToSize,
  showInfoNotification,
  openNotificationWithIcon,
  logMixpanelEvent
} from "../../../helpers";
import {
  getBasicSpecialities,
  updateDoctor,
  getPresignedUrl,
  uploadImageToS3
} from "../../../services";
import DoctorCertificateModal from "./DoctorCertificateModal";
export default class DoctorInfoContainer extends React.Component {
  state = {
    specialities: [],
    clinicId: localStorage.getItem("clinic_id"),
    animateDocInfo: false,
    uploading: false,
    apiArray: [],
    showCertificateModal: false,
    showDeleteCertificateModal: false,
    selectedOtherSpecialities: []
  };

  componentDidMount() {
    const animateDocInfo = localStorage.getItem("animate_doc_name_and_info");
    if (animateDocInfo === "true") {
      localStorage.removeItem("animate_doc_name_and_info");
      this.setState({ animateDocInfo: true });
    }
    this.getSpecialities();
    const { doctorsDetail } = this.props;
    if (doctorsDetail?.doctor?.other_specialities?.length > 0) {
      let otherSpecs = [];
      let otherSavedSpecs = doctorsDetail?.doctor?.other_specialities;
      otherSavedSpecs.map(obj => {
        otherSpecs.push({ name: obj.name, id: obj.id });
        return obj;
      });
      this.setState({ selectedOtherSpecialities: otherSpecs });
    }
  }

  /**
   * @function getSpecialities
   * @description Get Basic specialities
   */
  getSpecialities = (text = null) => {
    getBasicSpecialities(text).then(res => {
      if (res?.data?.hits?.hits?.length > 0) {
        let specialities = [];
        specialities = res.data.hits.hits.map(resObj => {
          const tempObj = resObj._source;
          return {
            name: tempObj.name,
            basic_speciality_id: tempObj.id,
            id: tempObj.id
          };
        });

        this.setState({
          specialities
        });
      } else {
        this.setState({
          specialities: []
        });
      }
    });
  };

  /**
   * @function handleSpecilitySearch
   * @description this function
   *  will handle search specilities list
   */
  handleSpecilitySearch = text => {
    const speciality = text.trim();
    this.getSpecialities(speciality === "" ? null : speciality);
  };

  /**
   * @func handlePreview
   * @param file
   * @desc it shows the image preview
   *
   */
  handlePreview = file => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true
    });
  };

  /**
   * @func handleChange
   * @param fileList
   * @desc it returns all the data of images
   */
  handleChange = data => {
    if (!this.state.maxLimitReached) {
      const checkFileSize = bytesToSize(data.file.size);

      const fileSize = parseInt(checkFileSize, 10);
      const fileSizeString = checkFileSize.replace(/\d/g, "");

      if (fileSizeString === "MB") {
        if (fileSize > 5) {
          showInfoNotification(
            "Image Size Warning",
            "Image size should not exceed 5MB"
          );
          return;
        }
      }

      if (fileSizeString === "KB") {
        if (fileSize > 5000) {
          showInfoNotification(
            "Image Size Warning",
            "Image size should not exceed 5MB"
          );
          return;
        }
      }

      const { fileList, file } = data;
      const { status } = file;
      const forApiArray = [];

      this.setState({ fileList, status }, () => {
        fileList.map(element => {
          const forApi = {
            id: element.id,
            photo_url: element.url,
            cover_photo: element.cover_photo || false,
            url: element.url
          };
          forApiArray.push(forApi);
        });
        this.setState({ apiArray: forApiArray });
      });
    }
  };

  /**
   * @func customRequest
   * @param file
   * @param onProgress
   * @desc it makes the request to upload image
   */
  customRequest = async ({ file, onProgress }) => {
    if (!this.state.maxLimitReached) {
      this.setState({ uploading: true });
      // this.props.toggleUploading();
      const checkFileSize = bytesToSize(file.size);
      const fileSize = parseInt(checkFileSize, 10);
      const fileSizeString = checkFileSize.replace(/\d/g, "");

      if (fileSizeString === "MB") {
        if (fileSize > 5) {
          return;
        }
      }

      if (fileSizeString === "KB") {
        if (fileSize > 5000) {
          return;
        }
      }

      // const { fileList, clinicId } = this.state;

      const { doctorsDetail } = this.props;
      const uniqueTimeStamp = new Date().getTime();
      const keyValue = `${process.env.REACT_APP_DOCTOR_MEDICAL_LICENSE_IMAGES_S3_FOLDER}/doctor_${doctorsDetail.doctor.id}/${uniqueTimeStamp}_${file.name}`;

      const params = {
        files: [
          {
            bucket: process.env.REACT_APP_S3_BUCKET,
            file_path: keyValue
          }
        ]
      };

      let response = await getPresignedUrl(params);
      let fileUrl = null;

      if (response && response.data && response.data.success) {
        fileUrl = response.data.data.ps_urls[0];
        const uploadResponse = await uploadImageToS3(fileUrl, file.type, file);
        if (uploadResponse && uploadResponse.status === 200) {
          this.setState({ uploading: false });
          showSuccessNotification("Certificate uploaded");
          const uploadedS3FileUrl = `https://${process.env.REACT_APP_S3_BUCKET}.s3.${process.env.REACT_APP_S3_REGION}.amazonaws.com/${keyValue}`;
          this.props.updateDoctorCertificate(uploadedS3FileUrl);
        }
      }
    }
  };

  /**
   * @func toggleCertificateModal
   * @description this will toggle the doctor certificate modal
   */
  toggleCertificateModal = () => {
    this.setState({
      showCertificateModal: !this.state.showCertificateModal
    });
  };

  /**
   * @func showCertificate
   * @description this will open doctor certificate modal
   */
  showCertificate = e => {
    const { showCertificateModal } = this.props;
    if (e) e.preventDefault();
    this.setState({ showCertificateModal: true });
  };

  /**
   * @func toggleDeleteCertificateModal
   * @description this will open delete certificate modal
   */
  toggleDeleteCertificateModal = e => {
    if (e) e.preventDefault();
    // Modal
    Modal.confirm({
      title: "Delete Certificate",
      content: "Are you sure you want to delete this",
      okText: "Yes",
      cancelText: "Cancel",
      cancelButtonProps: { type: "link" },
      onOk: () => {
        this.deleteDoctorCertificate();
      }
    });
  };

  /**
   * @func deleteDoctorCertificate
   * @description this function will remove doctor certificate.
   */
  deleteDoctorCertificate = () => {
    this.props.updateDoctorCertificateState();
    showSuccessNotification("Certificate Deleted");
    this.setState({ showDeleteCertificateModal: false });
  };

  /** @function handleSpecSelect
   * @param "selectedTag"
   * @desc - This function handles changes in speciality tag field
   */
  handleSpecSelect = selectedTag => {
    const { selectedOtherSpecialities } = this.state;

    const duplicateSpec = selectedOtherSpecialities.filter(item => {
      return item === selectedTag.name;
    });

    if (duplicateSpec.length > 0) {
      return;
    }
    const tags = [].concat(selectedOtherSpecialities, selectedTag);
    this.setState({ selectedOtherSpecialities: tags });
  };

  /**
   * @function handleTagDelete
   * @params i - index
   * @description Handles delete tag
   */
  handleTagDelete = i => {
    const tags = this.state.selectedOtherSpecialities.slice(0);
    tags.splice(i, 1);
    this.setState({
      selectedOtherSpecialities: tags
    });
  };

  handleSpecSearch = searchText => {
    if (searchText.length >= 3) {
      this.getSpecialities(searchText);
    }
  };

  render() {
    const {
      doctorsDetail,
      updateDoctorInfo,
      updateProcessing,
      getImageData,
      displayPhotos,
      regPhotoUrl
    } = this.props;
    const {
      specialities,
      animateDocInfo,
      uploading,
      showCertificateModal,
      showDeleteCertificateModal,
      selectedOtherSpecialities
    } = this.state;
    return (
      <div>
        <div className="table-with-search tbl-pd pb-10">
          <h4 className="header-title">{"Doctor Info"}</h4>
        </div>
        <DoctorInfoView
          specialities={specialities}
          doctorsDetail={doctorsDetail}
          updateDoctorInfo={updateDoctorInfo}
          updateProcessing={updateProcessing}
          handleSpecilitySearch={this.handleSpecilitySearch}
          animateDocInfo={animateDocInfo}
          handlePreview={this.handlePreview}
          handleChange={this.handleChange}
          customRequest={this.customRequest}
          uploading={uploading}
          // displayPhotos={displayPhotos}
          getImageData={getImageData}
          fileList={displayPhotos}
          regPhotoUrl={regPhotoUrl}
          showCertificateModal={showCertificateModal}
          showCertificate={this.showCertificate}
          showDeleteCertificateModal={showDeleteCertificateModal}
          toggleDeleteCertificateModal={this.toggleDeleteCertificateModal}
          deleteDoctorCertificate={this.deleteDoctorCertificate}
          selectedOtherSpecialities={selectedOtherSpecialities}
          handleSpecSelect={this.handleSpecSelect}
          handleTagDelete={this.handleTagDelete}
          handleSpecSearch={this.handleSpecSearch}
        />

        <DoctorCertificateModal
          regPhotoUrl={regPhotoUrl}
          showCertificateModal={showCertificateModal}
          toggleCertificateModal={this.toggleCertificateModal}
        />
      </div>
    );
  }
}
